var React = require('react');

function MoreInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Artboard"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"Artboard","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("path",{"d":"M24,30 C20.6862916,30 18,27.3137085 18,24 C18,20.6862915 20.6862916,18 24,18 C27.3137084,18 30,20.6862915 30,24 C30,27.3137085 27.3137084,30 24,30 Z M24,48 C20.6862916,48 18,45.3137085 18,42 C18,38.6862915 20.6862916,36 24,36 C27.3137084,36 30,38.6862915 30,42 C30,45.3137085 27.3137084,48 24,48 Z M24,12 C20.6862915,12 18,9.3137085 18,6 C18,2.6862915 20.6862915,0 24,0 C27.3137085,0 30,2.6862915 30,6 C30,9.3137085 27.3137085,12 24,12 Z","id":"Shape","fill":"#000000","fillRule":"nonzero"}))]);
}

MoreInline.defaultProps = {"width":"48px","height":"48px","viewBox":"0 0 48 48","version":"1.1"};

module.exports = MoreInline;

MoreInline.default = MoreInline;
